import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { AdhesionComponent } from './adhesion/adhesion.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'adhesion', redirectTo: 'c/adhesion' },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'transaction-history',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
    data: { redirect: 'transactions' }
  },
  {
    path: 'consultations',
    loadChildren: () => import('./consultations/consultations.module').then(m => m.ConsultationsModule)
  },
  {
    path: 'documents',
    loadChildren: () => import('./documents/documents.module').then(m => m.DocumentsModule)
  },
  {
    path: 'pronos',
    loadChildren: () => import('./pronos/pronos.module').then(m => m.PronosModule)
  },
  {
    path: 'quick-mode',
    loadChildren: () => import('./pronos/pronos.module').then(m => m.PronosModule),
    data: { redirect: 'quick-mode' }
  },
  {
    path: 'ranking',
    loadChildren: () => import('./ranking/ranking.module').then(m => m.RankingModule)
  },
  {
    path: 'game',
    loadChildren: () => import('./ball-game/ball-game.module').then(m => m.BallGameModule)
  },
  {
    path: 'games',
    loadChildren: () => import('./games/games.module').then(m => m.GamesModule)
  },
  {
    path: 'suggestions',
    loadChildren: () => import('./suggestions/suggestions.module').then(m => m.SuggestionsModule)
  },
  {
    path: 'wall-message',
    loadChildren: () => import('./wall-message/wall-message.module').then(m => m.WallMessageModule)
  },
  {
    path: 'c',
    loadChildren: () => import('./campaigns/campaigns.module').then(m => m.CampaignsModule)
  },
  {
    path: 'campaigns/confirmation',
    loadChildren: () => import('./campaigns/campaigns.module').then(m => m.CampaignsModule)
  },
  { path: '', component: LoginComponent },
  { path: '404', component: LoginComponent },
  { path: '**', component: LoginComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
